import React from "react";
import { Modal } from "antd";

import "../styles/components/popup.scss";

const Popup = ({
  isOpen,
  title,
  onOk,
  onCancel,
  children,
  footer,
  style,
  width,
  destroyOnClose,
  className = "",
}) => {
  const popupClassName = ["popup", className].filter(Boolean).join(" ");

  return (
    <>
      <Modal
        title={title}
        open={isOpen}
        onOk={onOk}
        onCancel={onCancel}
        footer={footer}
        style={style}
        width={width}
        className={popupClassName}
        destroyOnClose={destroyOnClose}
        styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
      >
        {children}
      </Modal>
    </>
  );
};

export default Popup;
